module.exports = __webpack_public_path__ + "img/focus.00d6adb0.png";